module.exports = __webpack_public_path__ + "static/googleplay-5c151b008288a4b4a4ad53f570f89b3d.svg";